import { LoadConfigService } from '../services/load-config.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UtilsService } from '../services/utils.service';
import { ReloadingService } from '../services/reloading.service';

const loadConfigService: LoadConfigService = new LoadConfigService(new UtilsService(), new ReloadingService());

const opacity: number = loadConfigService.getFadeOutOpacity();
const fadeOutTime: number = loadConfigService.getFadeOutTime();

export const FadeOutAnimationCopy = [
  trigger('fadeOutCopy', [
    state('*', style({ opacity: opacity })),
    transition(':enter', [style({ opacity: 1 }), animate(`${fadeOutTime}ms linear`, style({ opacity: opacity }))])
  ])
];
